// extracted by mini-css-extract-plugin
export default {"Container":"Wrapper_Container__ewHf6","NavButton":"Wrapper_NavButton__slTNU","PrevButton":"Wrapper_PrevButton__FNOo0","NextButton":"Wrapper_NextButton__Q+4b9"};